module.exports = __webpack_public_path__ + "faff92145777a3cbaf8e7367b4807987.woff";